import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { TachoTypeData } from '@src/app/enum/tacho.enum';

@Component({
  selector: 'app-tacho-data-details',
  templateUrl: './tacho-data-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./tacho-data-details.component.scss']
})
export class TachoDataDetailsComponent implements OnInit {

  public readonly TACHO_TYPE_DATA = TachoTypeData;

  @Input() public dataType: TachoTypeData;
  @Input() public data: any[] = [];
  @Input() public slotData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
